import React from 'react'
import { Input, FORM_TYPE } from '@shared/ui'

// Define the props interface
interface ScheduleRadioButtonProps {
  children?: React.ReactNode
  disabled?: boolean
  className?: string
  name: string
  value: string
  id: string 
}

export const ScheduleRadioButton: React.FC<ScheduleRadioButtonProps> = React.memo((props) => {
  const { children, disabled, className, name, value, id } = props

  return (
    <Input
      className={className}
      type={FORM_TYPE.radio}
      id={id}
      value={value}
      disabled={disabled}
      name={name}
    >
      {children}
    </Input>
  )
})
